import { makeStyles } from 'tss-react/mui';
import { spacing, statusColorsFlyingFlowers, statusColorsInterflora } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    container: {
        marginBottom: spacing.large,
    },
    dayPicker: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    errorMessage: Object.assign(Object.assign({}, theme.typography.small_regular), { color: theme.isFlyingFlowers ? statusColorsFlyingFlowers.error.base : statusColorsInterflora.error.base, marginTop: spacing.xs }),
}));
export default useStyles;
